import Table from "react-bootstrap/Table";

import { DischargeTypeTotal } from "@/services/sintegradaserver/discharge/getDischargeSummary";
import { DischargeType, dischargeTypeMessages } from "@/utils/enums/sintegrada/discharge/DischargeType";

import { TableSkeletons } from "@/components/TableSkeletons";

type Props = {
	isLoading: boolean;
	data: DischargeTypeTotal[];
};

export function DischargeResumeTable({ data, isLoading }: Props) {
	const hasData = Boolean(data?.length);

	return (
		<Table responsive className="bg-white" bordered>
			<thead className="fw-bolder">
				<tr>
					<th>Tipo de alta</th>
					<th>Total</th>
				</tr>
			</thead>
			<tbody>
				{!isLoading ? (
					hasData ? (
						data?.map((item, index) => {
							const dischargeType = dischargeTypeMessages[item.discharge_type as DischargeType];
							
							return (
								<tr key={`discharge-summary-${index}`}>
									<td>{dischargeType}</td>
									<td>{item.total}</td>
								</tr>
							);
						})
					) : (
						<tr>
							<td colSpan={12} className="text-center text-black-50 fw-bold">
								Nenhum resultado encontrado
							</td>
						</tr>
					)
				) : (
					<TableSkeletons numberOfCells={3} numberOfRows={15} height={15} />
				)}
			</tbody>
		</Table>
	);
}
